// The original spelling is stored; family-name capitals are display-only.
export const FULL_NAME = "full";
export const SEPARATE_NAMES = "separate";
export const nameEntryMode = value => value === SEPARATE_NAMES ? SEPARATE_NAMES : FULL_NAME;
export function nameFields(value = {}) {
  return { givenNames: String(value?.givenNames || ""), familyName: String(value?.familyName || "") };
}
export function composeIndividualName(value = {}, display = false) {
  const { givenNames, familyName } = nameFields(value);
  return [givenNames.trim(), display ? familyName.trim().toLocaleUpperCase() : familyName.trim()].filter(Boolean).join(" ");
}
export function individualNamePatch(value) {
  const fields = nameFields(value);
  return { ...fields, name: composeIndividualName(fields) };
}
export function capitalizeNameInitials(value) {
  return String(value || "").replace(/(^|[\s'’.-])(\p{L})/gu, (_, prefix, letter) => prefix + letter.toLocaleUpperCase());
}
// Never derive name parts by splitting full text. An explicit document split is required.
export function extractedNameFields(value = {}) {
  const givenNames = value.givenNames || value.given_names || value.firstName || "";
  const familyName = value.familyName || value.family_name || value.surname || value.lastName || "";
  return { givenNames: String(givenNames), familyName: String(familyName) };
}

export function nameFieldsForSubject(form, fullName) {
  const ownership = form?.ownership || {};
  const rows = [form?.customer, ...(ownership.shareholders || []), ...(ownership.ubos || []), ...(ownership.signatories || []),
    ...(ownership.legalArrangements?.arrangements || []).flatMap(a => a.parties || [])];
  const matches = rows.filter(row => row && String(row.name || "").trim().toLocaleLowerCase() === String(fullName || "").trim().toLocaleLowerCase());
  const values = [...new Set(matches.map(row => JSON.stringify(nameFields(row))))];
  return values.length === 1 ? JSON.parse(values[0]) : nameFields();
}

export function normalizeIndividualRecord(record = {}, mode = "full", individual = true) {
  if (!individual || mode !== "separate") return { ...record, ...nameFields() };
  const fields = nameFields(record);
  const name = composeIndividualName(fields);
  return { ...record, ...fields, ...(name ? { name } : {}) };
}
export function normalizeKycNames(form, mode = "full") {
  const normalizeParty = row => normalizeIndividualRecord(row, mode,
    !["entity", "company"].includes(String(row?.trusteeKind || row?.councilKind || row?.protectorKind || row?.guardianKind || "").toLowerCase()));
  const normalizeHolder = row => ({ ...normalizeIndividualRecord(row, mode,
    !["entity", "company", "trust", "foundation"].includes(String(row?.holderType || row?.type || "individual").toLowerCase())),
    ...(Array.isArray(row?.trustParties) ? { trustParties: row.trustParties.map(normalizeParty) } : {}),
    ...(Array.isArray(row?.foundationParties) ? { foundationParties: row.foundationParties.map(normalizeParty) } : {}) });
  const ownership = form?.ownership || {};
  return { ...form,
    customer: normalizeIndividualRecord(form?.customer, mode, form?.customer?.type !== "entity"),
    ownership: { ...ownership,
      ...(Array.isArray(ownership.shareholders) ? { shareholders: ownership.shareholders.map(normalizeHolder) } : {}),
      ...(Array.isArray(ownership.ubos) ? { ubos: ownership.ubos.map(normalizeHolder) } : {}),
      ...(Array.isArray(ownership.signatories) ? { signatories: ownership.signatories.map(row => normalizeIndividualRecord(row, mode)) } : {}),
      ...(ownership.legalArrangements ? { legalArrangements: { ...ownership.legalArrangements, arrangements: (ownership.legalArrangements.arrangements || []).map(arr => ({ ...arr, parties: (arr.parties || []).map(normalizeParty) })) } } : {}),
    },
  };
}
